import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EuiHeader, EuiHeaderSections } from 'stable-eui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { appConfig } from 'config';
import url from 'url';
import 'stable-eui/dist/eui_theme_amsterdam_light.min.css';
import { useHistory } from 'react-router-dom';
import { RootState } from 'reducers/root';
import { get } from 'lodash';
import { getMessage } from 'utils';
import { formatMoney } from 'utils/format';
import LanguageChooser from 'components/LanguageChooser';
import HeaderSpacesMenu from './headers/header.spaces.menu';
import HeaderUserMenu from './headers/header.user.menu';
import HeaderAppMenu from './headers/header.app.menu';
import HeaderSearchMenu from './headers/HeaderSearch/Menu';
import './styles.less';

function Header({ handleGlobalSearch, modalType }) {
  const appLoading = useSelector((state) => state.app.loading);
  const exchangeRate = useSelector((state) => state.app.exchangeRate);
  const profile = useSelector((state) => state.auth.profile);
  const pageList = useSelector((state) => state.auth.pageList);
  const postalList = useSelector((state) => state.auth.postalList);
  const currentWarehouse = useSelector((state) => state.auth.currentWarehouse);
  // const configMap = useSelector(
  //   (state: RootState) => state.app.appConfig.config_map
  // );
  // const dispatch = useDispatch();
  const history = useHistory();

  // const [currentRate, setCurrentRate] = React.useState(
  //   get(configMap, 'CURRENT_RMB_VN.value', '')
  // );
  const date = [
    {
      text: <span>{get(appConfig, 'release_date', 'v2.0.1')}</span>,
      style: {
        background: 'rgba(0,109,228,.2)',
      },
    },
  ];

  const exchangeRateBox = [
    {
      text: exchangeRate ? <span>{`1 RMB = ${exchangeRate || '-'} VND`}</span> : '',
    },
  ];

  // const warehouse = React.useMemo(() => {

  // }, [])

  const breadcrumbs = React.useMemo(() => {
    const brs = [];
    const t = pageList.find((i) => {
      const pagePath = url.parse(i.PAGE_PATH).pathname;
      return history.location.pathname === pagePath;
    });
    if (t && t.MENU_TITLE) {
      brs.push({
        text: getMessage(t.MENU_TITLE),
      });
    }

    brs.push({
      text: t ? getMessage(t.PAGE_TITLE) : getMessage('layout.common.home_page.title'),
    });

    return brs;
  }, [history.location.pathname]);

  // const renderCurrentRate = () => {
  //   return null;
  //   return (
  //     <EuiStat
  //       titleSize="s"
  //       title={formatMoney(currentRate) || '-'}
  //       description="RMB-VND"
  //       textAlign="left"
  //     />
  //   );
  // };

  const sections = [
    {
      items: [<HeaderSpacesMenu />],
      borders: 'right',
      breadcrumbs: breadcrumbs,
    },
    // {
    //   items: [],
    //   borders: 'right',
    //   breadcrumbs: date,
    //   breadcrumbProps: {
    //     className: 'date-bread',
    //   },
    // },

    {
      items: [
        <HeaderSearchMenu modalType={modalType} handleGlobalSearch={handleGlobalSearch} />,
        <div className='empty-block-custom' />,
      ],
      // breadcrumbs: exchangeRateBox,
      borders: 'none',
      grow: true,
    },
    // {
    //   items: [
    //     <LanguageChooser compressed={true} />,
    //     <div style={{ width: 8 }} />,
    //   ],
    //   borders: 'none',
    // },
    {
      items: [
        <HeaderUserMenu
          currentWarehouse={currentWarehouse}
          profile={profile}
          changePostal={() => {}}
          // warehouse={warehouse}
          postalList={postalList}
        />,
        <HeaderAppMenu />,
      ],
    },
  ];

  React.useEffect(() => {
    if (appLoading) {
      NProgress.start();
      NProgress.set(0.7);
    } else {
      NProgress.done();
    }
  }, [appLoading]);

  // React.useEffect(() => {
  //   setInterval(() => {
  //     setCurrentRate(currentRate > 3600 ? 3500 : currentRate + random(1, 100));
  //   }, 5000);
  // }, []);

  return <EuiHeader className='header-top' sections={sections} />;
}

export default Header;
